import React from 'react';
import { declOfNum } from '@ertelecom/ui-react/components/helpers';
import DefaultPopup from '@ertelecom/ui-react/components/popups/defaultPopup';
import styled from 'styled-components';
import { RequestForm } from '~/src/components/RequestForm';

const PopupHeader = styled.div`
    background: linear-gradient(205.3deg, #FCFDFF 0%, #E9EAEF 100%);
    padding: 30px 50px;
    width: 100%;
    display: flex;
    flex-direction: column;
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
`;
const PopupBody = styled.div`
    padding: 40px 50px;
    width: 100%;
    display: flex;
    flex-direction: column;
`;
const PopupEquip = styled.div`
    font-size: 16px;
    line-height: 20px;
`;
const PopupTitle = styled.div`
    font-size: 20px;
    line-height: 28px;
`;
const OrderLine = styled.div`
    font-size: 20px;
    line-height: 28px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #EBEBEB;
    padding-bottom: 30px;    
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
`;
const OrderPrice = styled.div`
    font-size: 20px;
    line-height: 28px;
    display: flex;
    align-items: center;
`;
const OrderPriceInfo = styled.div`
    font-size: 14px;
    line-height: 18px;
    padding: 3px 0 0 5px;
`;
const FormTitle = styled.div`
    font-size: 16px;
    line-height: 20px;
    margin: 30px 0;    
    font-family: 'robotoRegular', Arial, Helvetica, sans-serif;
`;

const PopupConteiner = styled.div`
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    display: flex;
    flex-direction: column;
    align-items: baseline;
`;

const Popup = styled(DefaultPopup)`
    z-index: 100;
`;

export const OrderPopup = ({ isOpened, closeClick, sendRequest, selectEquip, isLoading, isPopup }) => {

    /**
     * Возвращает данные по типу оплаты
     *
     * @function
     * @name components.getDataType
     * @param {{equip: object, option: object}} selectEquip - объект с данными по выбранной карточке
     * @returns {{type: string, isBuy: boolean}}
     */
    const getDataType = (selectEquip) => {
        const orderText = declOfNum(['месяц', 'месяца', 'месяцев']);
        const purchaseType = 1;
        const { value, type } = selectEquip.option;
        const isBuy = type === purchaseType;
        return {
            type: isBuy ? 'Покупка' : `Рассрочка ${value} ${orderText(value)}`,
            isBuy,
        };
    };

    const renderOrderLine = () => {
        if (selectEquip) {
            const { price } = selectEquip.option;
            return (
                <OrderLine>
                    {getDataType(selectEquip).type}
                    <OrderPrice>
                        { price }
                        <OrderPriceInfo>{ getDataType(selectEquip).isBuy ? '₽' : '₽/мес' }</OrderPriceInfo>
                    </OrderPrice>
                </OrderLine>
            );
        }
    };

    const name = selectEquip?.equip?.title || selectEquip?.equip?.mat_name;

    const getOption = () => {
        if (selectEquip) {
            return { option: `${name} | ${getDataType(selectEquip).type }` };
        }
        return { option: '' };
    };

    return (
        <Popup isOpen={ isOpened } onClose={ closeClick } width='730px'>
            <PopupConteiner>
                <PopupHeader>
                    <PopupEquip>{ name || '' }</PopupEquip>
                    <PopupTitle>Оформление заявки на заказ</PopupTitle>
                </PopupHeader>
                <PopupBody>
                    { renderOrderLine() }
                    <FormTitle>Оставьте заявку и мы вам перезвоним для уточнения деталей</FormTitle>
                    <RequestForm
                        submitRequest={sendRequest}
                        isLoading={isLoading}
                        isPopup={isPopup}
                        {...getOption()}
                    />
                </PopupBody>
            </PopupConteiner>
        </Popup>
    );
};
